import React from "react";
import { useState } from "react";
import "./Login.css";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";
import Cookies from "js-cookie";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Toast from "react-bootstrap/Toast";
import ToastContainer from "react-bootstrap/ToastContainer";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = React.useState(false);
  const [allDetails, setAllDetails] = useState(true);
  const [buttonText, setButtonText] = useState("Sign In");
  const navigate = useNavigate();
  const [showA, setShowA] = useState(false);
  const [showB, setShowB] = useState(false);

  const toggleShowA = () => setShowA(!showA);
  const toggleShowB = () => setShowB(!showB);

  function handleemailChange(event) {
    setEmail(event.target.value);
  }

  function handlePasswordChange(event) {
    setPassword(event.target.value);
  }
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  async function handleSubmit() {
    if (!email || !password) {
      setAllDetails(false);
      return;
    }
    setAllDetails(true);
    setButtonText("Signing In.....");
    await axios
      .post(`https://vickygaming.onrender.com/api/v1/users/login`, {
        email: email,
        password: password,
        returnSecureToken: true,
      })
      .then((response) => {
        Cookies.set("token", response.data.token, { expires: 30 });
        Cookies.set("userName", response.data.data.user.name, {
          expires: 30,
        });
        Cookies.set("email", response.data.data.user.email, {
          expires: 30,
        });
        setButtonText("Sign In");

        toggleShowB();

        navigate("/");
      })
      .catch((error) => {
        console.log(error);
        setButtonText("Sign In");
        if (error.response.data.message === "'Incorrect password or email") {
          toggleShowA();
        }
      });
  }

  return (
    <section className="login">
      <ToastContainer position="top-end" className="p-3" style={{ zIndex: 1 }}>
        <Toast
          show={showA}
          onClose={toggleShowA}
          delay={3000}
          autohide
          bg="danger"
        >
          <Toast.Body>Incorrect Username or password</Toast.Body>
        </Toast>
      </ToastContainer>

      <ToastContainer position="top-end" className="p-3" style={{ zIndex: 1 }}>
        <Toast
          show={showB}
          onClose={toggleShowB}
          delay={3000}
          autohide
          bg="success"
        >
          <Toast.Body>Successfully Logged In!</Toast.Body>
        </Toast>
      </ToastContainer>

      <div
        className="d-flex align-items-center justify-content-center"
        style={{ height: "750px" }}
      >
        {/* style={{ width: "18rem" }} */}
        <Card>
          <div
            className="card-header text-center text-md-center"
            style={{ borderColor: "#fff" }}
          >
            <h1
              className="mb-1 mt-1"
              style={{ fontSize: "25px", fontWeight: 700 }}
            >
              Login
            </h1>
          </div>
          <Card.Body className="px-5">
            <Form>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label style={{ color: "#fff", fontWeight: 700 }}>
                  Your Email
                </Form.Label>
                <br />
                <input
                  type="text"
                  name="email"
                  value={email}
                  placeholder="abc@gmail.com"
                  onChange={handleemailChange}
                  style={{
                    padding: "10px 25px",
                    borderRadius: "5px",
                    border: "none",
                  }}
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label style={{ color: "#fff", fontWeight: 700 }}>
                  Your Password
                </Form.Label>
                <br />
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={password}
                  placeholder="password"
                  onChange={handlePasswordChange}
                  style={{
                    padding: "10px 25px",
                    borderRadius: "5px",
                    border: "none",
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicCheckbox">
                <Form.Check
                  type="checkbox"
                  label="Show Password"
                  style={{ color: "#fff" }}
                  onClick={handleClickShowPassword}
                />
              </Form.Group>
              <div className="d-flex align-items-center justify-content-center mt-2 mb-2">
                <Button variant="primary" onClick={handleSubmit}>
                  {buttonText}
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </div>
    </section>
  );
}
